import { request } from './request'

// 获取功能模块
export const getModules = () => {
  return request({
    method: 'get',
    url: '/api/v1/audit-log/module'
  })
}

// 任务中心列表接口
export const getSyncTaskList = data => {
    return request({
      method: 'post',
      url: '/ocean/api/v1/shop/syn-task/page',
      data
    })
  }

// 获取同步时间列表接口
export const getSyncTimeList = (params, shop_id) => {
  return request({
    method: 'get',
    url: `/ocean/api/v1/shop/syn-task/syn-time/list/${shop_id}`,
    params
  })
}

// 店铺同步日志列表接口
export const getSyncTaskDetail = data => {
  return request({
    method: 'post',
    url: `/ocean/api/v1/shop/syn-task/detail/page`,
    data
  })
}

// 店铺同步日志信息接口
export const getSyncTaskDetailMessage = data => {
  return request({
    method: 'post',
    url: `/ocean/api/v1/shop/syn-task/detail/message`,
    data
  })
}

// 重试专辑同步失败重试
export const syncFailData = data => {
  return request({
    method: 'post',
    url: `/ocean/api/v1/product/collections/retrySyncCollection`,
    data
  })
}

// 店铺同步失败重试
export const syncRetryFail = params => {
  return request({
    method: 'post',
    url: `/ocean/api/v1/shop/syn-task/retry-fail`,
    params
  })
}

// 结束同步
export const postEndSync = data => {
  return request({
    method: 'post',
    url: `/ocean/api/v1/shop/syn-task/detail/stopSyn`,
    data
  })
}
